export const VENDOR_FORGOT_PASSWORD_REQUEST = "VENDOR_FORGOT_PASSWORD_REQUEST";
export const VENDOR_FORGOT_PASSWORD_SUCCESS = "VENDOR_FORGOT_PASSWORD_SUCCESS";
export const VENDOR_CONFIRM_RESET_TOKEN_REQUEST =
    "VENDOR_CONFIRM_RESET_TOKEN_REQUEST";
export const VENDOR_CONFIRM_RESET_TOKEN_SUCCESS =
    "VENDOR_CONFIRM_RESET_TOKEN_SUCCESS";
export const VENDOR_RESET_PASSWORD_REQUEST = "VENDOR_RESET_PASSWORD_REQUEST";
export const VENDOR_RESET_PASSWORD_SUCCESS = "VENDOR_RESET_PASSWORD_SUCCESS";
export const CLEAR_VENDOR_FORGOT_RESPONSE = "CLEAR_VENDOR_FORGOT_RESPONSE";
